// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"16d80fed","453":"a4a84ada","455":"dc944a89","977":"6eccdb97"}[chunkId] + ".chunk.js";
};